module.exports = __webpack_public_path__ + "static/media/icon-calculator.cfc7ff45.svg";